export const WEBSITE_VIEW_QUERY_PARAM = 'view';

export const WebsiteView = {
  Bubble: 'bubble',
  Embed: 'embed',
  ChatPage: 'chat_page',
} as const;

export type WebsiteView = (typeof WebsiteView)[keyof typeof WebsiteView];

export const isValidWebsiteView = (value: string | null): value is WebsiteView =>
  value === WebsiteView.Bubble || value === WebsiteView.Embed || value === WebsiteView.ChatPage;
